/**
 * Prenos datoteke iz brskalnika.
 *
 * `showSaveFilePicker()` bi bil lepši, a ga ima le Chromium — Safari in
 * Firefox ga nimata, iOS pa sploh ne. Sidro z `download` je edina pot, ki
 * deluje povsod, kjer aplikacija teče.
 */
export function downloadJson(fileName: string, data: unknown): void {
  const blob = new Blob([JSON.stringify(data, null, 2)], {
    type: 'application/json',
  });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  // Sidro mora biti v dokumentu, sicer ga Firefox ne sproži.
  document.body.append(link);
  link.click();
  link.remove();

  // Naslov sprosti šele naslednja naloga: prezgodnji `revokeObjectURL()`
  // prenos prekine, ker ga brskalnik še ni začel.
  setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 0);
}

/** Prebere izbrano datoteko kot besedilo; `null`, kadar branje ne uspe. */
export async function readTextFile(file: File): Promise<string | null> {
  try {
    return await file.text();
  } catch {
    return null;
  }
}
